// extracted by mini-css-extract-plugin
var _1 = "IncompleteElementModal_elements__0463d";
var _2 = "IncompleteElementModal_empty__9a576";
var _3 = "IncompleteElementModal_header__71d05";
var _4 = "IncompleteElementModal_hint__0fbf7";
var _5 = "IncompleteElementModal_label__81322";
export { _1 as "elements", _2 as "empty", _3 as "header", _4 as "hint", _5 as "label" }
